// extracted by mini-css-extract-plugin
module.exports = {"news-banner-box":"bm","newsBannerBox":"bm","banner-wrap":"bn","bannerWrap":"bn","banner-title":"bo","bannerTitle":"bo","banner-img-box":"bp","bannerImgBox":"bp"};